import { createReducer, on } from '@ngrx/store';

import { DocumentState } from '../state/document.state';
import {
    saveSelectedDiscrepancy,
    saveSummaryPanelData,
} from '../actions/document.actions';

export const initialState: DocumentState = {
    selectedDocument: null,
    selectedDiscrepancy: null,
    selectedTab: null,
};

export const documentReducer = createReducer(
    initialState,
    on(
        saveSummaryPanelData,
        (
            state,
            {
                selectedDocument = null,
                selectedDiscrepancy,
                selectedTab = null,
            },
        ): DocumentState => ({
            ...state,
            selectedDocument,
            selectedDiscrepancy,
            selectedTab,
        }),
    ),
    on(
        saveSelectedDiscrepancy,
        (state, { selectedDiscrepancy }): DocumentState => ({
            ...state,
            selectedDiscrepancy,
        }),
    ),
);
